"use client";

import { c as _c } from "react/compiler-runtime";
import { Close } from "@mui/icons-material";
import ComponentLoading from "@/components/global/component-loading";
import useIsMobile from "@/hooks/use-mobile";
import { useGetThemeQuery } from "@/queries/theme/use-get-theme";
import { useClubsFiltersOpenedStore, useClubsFiltersStore, useClubsFiltersThemeShowStore } from "@/stores/clubs-filters-store";
import ClubFilterThemeItem from "./ClubFilterThemeItem";
export default function ClubFilterTheme() {
  const $ = _c(27);
  const isMobile = useIsMobile();
  const {
    data: themesData,
    isLoading: isThemesLoading,
    error: themesError
  } = useGetThemeQuery();
  let t0;
  if ($[0] !== themesData) {
    t0 = themesData?.["hydra:member"] || [];
    $[0] = themesData;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const themesList = t0;
  const filterThemeOpened = useClubsFiltersOpenedStore(_temp);
  const setFiltersThemeOpened = useClubsFiltersOpenedStore(_temp2);
  const setFiltersClosed = useClubsFiltersOpenedStore(_temp3);
  const themeShow = useClubsFiltersThemeShowStore(_temp4);
  const removeThemeShow = useClubsFiltersThemeShowStore(_temp5);
  const removeThemeStore = useClubsFiltersStore(_temp6);
  let t1;
  if ($[2] !== removeThemeShow || $[3] !== removeThemeStore || $[4] !== setFiltersClosed) {
    t1 = () => {
      removeThemeShow();
      removeThemeStore("");
      setFiltersClosed();
    };
    $[2] = removeThemeShow;
    $[3] = removeThemeStore;
    $[4] = setFiltersClosed;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const removeTheme = t1;
  if (themesError) {
    console.error("Erreur dans ClubFilterTheme:", themesError);
    let t2;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <p className="font-bold">Thèmatique du club non disponible</p>;
      $[6] = t2;
    } else {
      t2 = $[6];
    }
    const t3 = themesError.message || "Erreur inconnue";
    let t4;
    if ($[7] !== t3) {
      t4 = <div className="w-[36%] flex flex-col justify-center items-start px-4">{t2}<p className="text-sm text-red-500">{t3}</p></div>;
      $[7] = t3;
      $[8] = t4;
    } else {
      t4 = $[8];
    }
    return t4;
  }
  const t2 = `relative w-[36%] ${isMobile ? "w-full" : "w-[36%]"}`;
  const t3 = `w-[100%] flex flex-col justify-center items-start hover:cursor-pointer ${isMobile ? "" : "px-4"}`;
  let t4;
  if ($[9] !== setFiltersThemeOpened) {
    t4 = () => setFiltersThemeOpened();
    $[9] = setFiltersThemeOpened;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <p className="font-bold">Thèmatique du club</p>;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== removeTheme || $[13] !== themeShow) {
    t6 = themeShow ? <div className="flex flex-row gap-2 overflow-x-auto"><p className="text-sm font-bold bg-yellow rounded-[15px] px-2 flex flex-row gap-2 items-center">{themeShow}<Close style={{
          width: "15px",
          height: "15px"
        }} onClick={e => {
          removeTheme();
          e.stopPropagation();
        }} /></p></div> : <p className="text-grey text-sm">ex: Padel, 100% Féminin, Digital...</p>;
    $[12] = removeTheme;
    $[13] = themeShow;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t3 || $[16] !== t4 || $[17] !== t6) {
    t7 = <div className={t3} onClick={t4}>{t5}{t6}</div>;
    $[15] = t3;
    $[16] = t4;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== filterThemeOpened || $[20] !== isThemesLoading || $[21] !== themesList) {
    t8 = filterThemeOpened && <div className="px-[2%]"><div className="absolute flex flex-row flex-wrap justify-between top-[70px] bg-white z-10 w-[100%] h-[auto] border border-light-grey rounded-[5px] shadow-md gap-2 p-2">{isThemesLoading ? <div className="w-full h-full flex items-center justify-center"><ComponentLoading /></div> : themesList.map(_temp7)}</div></div>;
    $[19] = filterThemeOpened;
    $[20] = isThemesLoading;
    $[21] = themesList;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  let t9;
  if ($[23] !== t2 || $[24] !== t7 || $[25] !== t8) {
    t9 = <div className={t2}>{t7}{t8}</div>;
    $[23] = t2;
    $[24] = t7;
    $[25] = t8;
    $[26] = t9;
  } else {
    t9 = $[26];
  }
  return t9;
}
function _temp7(theme) {
  return <ClubFilterThemeItem icon={theme.icon.slug} name={theme.name} label={theme.code} key={theme.id} />;
}
function _temp6(state_4) {
  return state_4.setTheme;
}
function _temp5(state_3) {
  return state_3.removeThemeShow;
}
function _temp4(state_2) {
  return state_2.themeShow;
}
function _temp3(state_1) {
  return state_1.setFiltersClosed;
}
function _temp2(state_0) {
  return state_0.setFilterThemeOpened;
}
function _temp(state) {
  return state.themeOpened;
}